import { useEffect, useState } from 'react';
import { useRpmPatientDetails } from 'infrastructure/hooks/rpm';
import { useDispatch } from 'react-redux';
import { useInterval } from 'react-use';
import { DoNotCallRestrictionType } from 'infrastructure/enums';
import { usePatientDoNotCallInfo } from 'infrastructure/hooks/control-panel/use-do-not-call-info';

import type React from 'react';

const default_delay = 60_000;

interface IProps {
  patientGuid: string;
  delay?: number;
}

const CallTimer: React.FC<IProps> = ({
  patientGuid,
  delay = default_delay,
}) => {
  const {
    query: { patient },
  } = useRpmPatientDetails({ patientGuid });

  const [_, forceRecalc] = useState(Date.now());

  const {
    patient: { setPatientDoNotCallInfo },
  } = useDispatch();

  const {
    doNotCallRpm,
    doNotCallCcm,
    rpmDoNotCallReasonMessage,
    ccmDoNotCallReasonMessage,
    rpmRestrictionType,
    ccmRestrictionType,
  } = usePatientDoNotCallInfo({ patientGuid });

  const isRpmFullLimitedHours =
    rpmRestrictionType === DoNotCallRestrictionType.LimitedHours;
  const isCcmFullLimitedHours =
    ccmRestrictionType === DoNotCallRestrictionType.LimitedHours;

  const startInterval =
    (doNotCallRpm && isRpmFullLimitedHours) ||
    (doNotCallCcm && isCcmFullLimitedHours);

  useEffect(() => {
    if (!patient) return;

    setPatientDoNotCallInfo({
      doNotCallRpm,
      doNotCallCcm,
      rpmRestrictionType,
      ccmRestrictionType,
      rpmDoNotCallReasonMessage,
      ccmDoNotCallReasonMessage,
    });
  }, [
    patient,
    doNotCallRpm,
    doNotCallCcm,
    rpmRestrictionType,
    ccmRestrictionType,
    rpmDoNotCallReasonMessage,
    ccmDoNotCallReasonMessage,
  ]);

  useInterval(
    () => {
      forceRecalc(Date.now());
    },
    patient && startInterval ? delay : null,
  );

  if (!patient) return null;

  return null;
};

export default CallTimer;
